import { ChatEntityFeatureFlagsProvider } from "@/components/shared/chat-feature-flags-context";
import { ReplyType } from "@sendbird/chat/message";
import SBConversation from "@sendbird/uikit-react/Channel";
import { useCallback } from "react";
import { MessageItem } from "../conversations/message-item";

interface ChannelDetailsProps {
  currentChannelUrl?: string | null;
  channelHeader: React.ReactElement;
  messageInput: React.ReactElement;
}

const SB_QUERIES = {
  messageListParams: {
    includeParentMessageInfo: true,
    replyType: ReplyType.ALL,
  },
};

const renderMessage = ({ message }: { message: Parameters<typeof MessageItem>[0]["message"] }) => (
  <MessageItem message={message} />
);

export const ChannelDetails = ({
  currentChannelUrl,
  channelHeader,
  messageInput,
}: ChannelDetailsProps) => {
  const renderMessageInput = useCallback(() => messageInput, [messageInput]);
  const renderChannelHeader = useCallback(() => channelHeader, [channelHeader]);

  if (!currentChannelUrl) {
    return null;
  }

  return (
    <ChatEntityFeatureFlagsProvider>
      <SBConversation
        queries={SB_QUERIES}
        channelUrl={currentChannelUrl}
        renderMessageInput={renderMessageInput}
        renderChannelHeader={renderChannelHeader}
        renderMessage={renderMessage}
        replyType="QUOTE_REPLY"
      />
    </ChatEntityFeatureFlagsProvider>
  );
};
